import { ReactNode, memo, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Skeleton } from 'antd';
import menuGuard from '../../utils/menuGuard';
import { useGetSideNavMenusQuery } from '../Admin/Menu/store/menuAdminSlice';

interface MenuGuardProp {
  children?: ReactNode;
}

function ActiveMenuGuard(props: MenuGuardProp) {
  const { children } = props;
  const { data: menuData, isLoading } = useGetSideNavMenusQuery();
  const currentPath = window.location.pathname;
  const [menuLoaded, setMenuLoaded] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setMenuLoaded(true);
    }
  }, [isLoading]);

  if (
    currentPath === '/' ||
    currentPath.startsWith('/admin') ||
    currentPath.startsWith('/error') ||
    currentPath.startsWith('/user-list')
  ) {
    return <>{children}</>;
  }

  if (!menuLoaded) {
    return (
      <div>
        <Skeleton
          className="bg-white dark:bg-[#0A0A0A] p-10"
          active
          paragraph={{ rows: 30 }}
        />
      </div>
    ); // Display a loading component while menu data is loading
  }
  // @ts-ignore
  const statusMatched = menuGuard(currentPath, menuData, isLoading);

  return statusMatched ? <>{children}</> : <Navigate to="/error-forbidden" />;
}

export default memo(ActiveMenuGuard);
